import {AbstractStorage} from "./AbsctractStorage";

export class SessionStorage extends AbstractStorage {
    set(key, value) {
        if(value !== undefined && value !== null) {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    }
    get(key) {
        if(sessionStorage.getItem(key) !== undefined && sessionStorage.getItem(key) !== null && sessionStorage.getItem(key) !== {}) {
            return JSON.parse(sessionStorage.getItem(key));
        }
        return undefined;
    }
    remove(key) {
        sessionStorage.removeItem(key);
    }
    clear() {
        sessionStorage.clear();
    }
}


// WEBPACK FOOTER //
// ./src/storage/SessionStorage.js